import { SlideConfirmModal } from '../../../../../components/common/modal/slide/SlideConfirmModal';
import { ProductFilterController } from './components/ProductFilterController/ProductFilterController';

interface ProductFilterSlideModalProps {
  isShow: boolean;
  closeModal: () => void;
}

export const ProductFilterSlideModal = ({ isShow, closeModal }: ProductFilterSlideModalProps) => {
  return (
    <SlideConfirmModal
      isShow={isShow}
      height={700}
      element={<ProductFilterController closeModal={closeModal} />}
      closeButton={{ handleClick: closeModal }}
      isShowCloseButton
      gap={'0px'}
      padding={'0px'}
    />
  );
};
